import { IResult } from '~src/httpClient/serverApi/types/IResponse';

import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { BaasEdgePoolError } from '../../sections/types/BaasEdgePoolError';

export interface ISetSmbVolumesParams {
    poolId: string;
    domain: string;
    username: string;
    password: string;
    path: string;
    dryRun: boolean;
}

export interface ISetSmbVolumesResult extends IResult {
    success?: {
        poolId: string;
    };
    error?: BaasEdgePoolError;
}

export class SetSmbVolumesRequest extends Request<ISetSmbVolumesParams, ISetSmbVolumesResult> {
  constructor(params: ISetSmbVolumesParams) {
    super('setSmbVolumeForPool', params);
  }
}
